import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-0"}],["path",{"d":"M3 8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -8","key":"svg-1"}],["path",{"d":"M18 12h.01","key":"svg-2"}],["path",{"d":"M6 12h.01","key":"svg-3"}]]

const IconCashBanknote = createReactComponent('outline', 'cash-banknote', 'CashBanknote', __iconNode);

export default IconCashBanknote;